import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './Stats.css';

const Stats = () => {
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true
  });

  const statsData = [
    { value: 20, suffix: '+', label: 'YEARS EXPERIENCE' },
    { value: 125, suffix: '+', label: 'LEGAL ENTITIES' },
    { value: 2, suffix: 'B+', label: 'PORTFOLIO VALUE' },
    { value: 8, suffix: '', label: 'CERTIFICATIONS' }
  ];

  const [counters, setCounters] = useState(statsData.map(() => 0));

  useEffect(() => {
    if (inView) {
      statsData.forEach((stat, index) => {
        let start = 0;
        const end = stat.value;
        const duration = 2000;
        const increment = end / (duration / 16);

        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            setCounters(prev => {
              const newCounters = [...prev];
              newCounters[index] = end;
              return newCounters;
            });
            clearInterval(timer);
          } else {
            setCounters(prev => {
              const newCounters = [...prev];
              newCounters[index] = Math.floor(start);
              return newCounters;
            });
          }
        }, 16);

        return () => clearInterval(timer);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <section id="stats" className="stats-section">
      <div className="container">
        <div className="stats-grid" ref={ref}>
          {statsData.map((stat, index) => (
            <div key={index} className={`stat-item ${inView ? 'fade-in' : ''}`} style={{ animationDelay: `${index * 0.1}s` }}>
              <h2 className="stat-value">
                {counters[index]}{stat.suffix}
              </h2>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;

